const heights = {
  data() {
    return {
      mobileHeight: 60,
      desktopHeight: 40,
    };
  },
};

export default heights;
